export default {
  'department.department': 'دپارتمان',
  'department.name': 'نام دپارتمان',
  'department.englishname': 'نام انگلیسی دپارتمان',
  'department.persianname': 'نام فارسی دپارتمان',
  'department.code': 'کد دپارتمان',
  'department.add': 'ثبت دپارتمان',
  'department.title': 'مدیریت دپارتمان',
  'department.departmentdel': 'حذف دپارتمان',
  'department.departmentadd': 'دپارتمان با موفقیت ثبت گردید ',
  'department.departmentdelete': 'با موفقیت حذف گردید',
  'department.deleteerror': 'رکورد مورد نظر در حال استفاده می باشد',
  'department.departmentaddInformation': 'اطلاعات شما با موفقیت ویرایش گردید',
};
